export const APP_NAME = "Moby";
export const TITLE_SEPARATOR = " · ";
